import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { PlantTypeService } from '../proxy/general/controllers/plant-type.service';
import { SpeciesGroupService } from '@general/proxy/general/controllers';

FieldBuilder.setNamespace('General');

export const SPECIESGROUPPLANTTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isMain', 'Entity.SpeciesGroupPlantType.IsMain')
    .build(),
  FieldBuilder.foreignKey(
    'specieGroupId',
    'Entity.SpeciesGroupPlantType.SpeciesGroup',
    SpeciesGroupService
  )
    .required()
    .displayFromNested('specieGroup.name')
    .sortBy('specieGroup.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey(
    'plantTypeId',
    'Entity.SpeciesGroupPlantType.PlantType',
    PlantTypeService
  )
    .required()
    .displayFromNested('plantType.name')
    .sortBy('plantType.name')
    .build(),
];

export const SPECIESGROUPPLANTTYPE_CONFIG = {
  entityName: 'SpeciesGroupPlantType',
  localizationKey: 'General::Entity.SpeciesGroupPlantType',
  fields: SPECIESGROUPPLANTTYPE_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SpeciesGroupPlantTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
